var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30799 15.694C5.71865 16.102 6.38445 16.102 6.7951 15.694L12 10.5224L17.2049 15.694C17.6156 16.102 18.2814 16.102 18.692 15.694C19.1027 15.286 19.1027 14.6244 18.692 14.2164L12.7436 8.30602C12.3329 7.89799 11.6671 7.89799 11.2564 8.30602L5.30799 14.2164C4.89734 14.6244 4.89734 15.286 5.30799 15.694Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.cec57edae84b98d5484b0a8a097045e9.svg";
export { ForwardRef as ReactComponent };